export default "__VITE_ASSET__Czgl1N0F__"